/** Shared campaign type vocabulary for the unified Campaigns UI. */

export const CAMPAIGN_TYPES = ['system', 'marketing', 'maintenance', 'emergency'];

export const CAMPAIGN_TYPE_META = {
  system: { label: 'System', tagColor: 'blue', pushType: 'app_update' },
  marketing: { label: 'Marketing', tagColor: 'cyan', pushType: null },
  maintenance: { label: 'Maintenance', tagColor: 'orange', pushType: 'maintenance' },
  emergency: { label: 'Emergency', tagColor: 'red', pushType: 'emergency' },
};

export const CAMPAIGN_STATUS_COLORS = {
  draft: 'default',
  scheduled: 'blue',
  sending: 'gold',
  sent: 'green',
  failed: 'red',
  cancelled: 'default',
};

export const CAMPAIGN_AUDIENCE_LABELS = {
  clients: 'Clients (policy holders)',
  admins: 'Admin users',
  enrollees: 'Enrollees',
  facility_admins: 'Facility admins (providers)',
  orgs: 'Organizations',
};

/**
 * @param {{ channels: { push?: boolean, email?: boolean }, type: string, title?: string, subject?: string, body?: string, body_html?: string, audiences?: string[] }} values
 * @returns {string | null}
 */
export function validateCampaignForm(values) {
  const push = Boolean(values.channels?.push);
  const email = Boolean(values.channels?.email);
  if (!push && !email) return 'Select at least one channel (Push or Email)';

  if (!CAMPAIGN_TYPES.includes(values.type)) {
    return 'Please select a campaign type';
  }

  if (push && values.type === 'marketing') {
    return 'Marketing campaigns cannot use Push — email only, or change the type';
  }

  if (push) {
    const title = (values.title || values.subject || '').trim();
    const body = (values.body || stripHtml(values.body_html || '')).trim();
    if (!title) return 'Title is required for push';
    if (title.length > 60) return 'Push title must be 60 characters or fewer';
    if (!body) return 'Message body is required for push';
    if (body.length > 250) return 'Push body must be 250 characters or fewer';
  }

  if (email) {
    if (!Array.isArray(values.audiences) || values.audiences.length === 0) {
      return 'Select at least one audience for email';
    }
    if (!(values.subject || values.title || '').trim()) return 'Subject is required for email';
    if (!(values.body_html || values.body || '').trim()) return 'Email body is required';
  }

  return null;
}

export function stripHtml(html) {
  return String(html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function pushTypeForCampaign(type) {
  return CAMPAIGN_TYPE_META[type]?.pushType || null;
}
